import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './../components/login/login.component';
import {IsAliveComponent } from './../components/is-alive/is-alive.component';
import { SubscriptionComponent } from './../components/subscription/subscription.component';
import { ConsultationComponent } from './../components/consultation/consultation.component';
import { PanelComponent } from './../components/panel/panel.component';
import { AuthenticationService } from './../services/authentication.service';
import { DPO_CONSTANT } from './../utils/constant';
import { SubscriptionValidatedComponent } from '../components/subscription-validated/subscription-validated.component'; // CAP-26096_POUDG-8493: Lot-2 related changes

// Define the routing paths
const routes: Routes = [
  { path: '', component: LoginComponent},
  { path: DPO_CONSTANT.PATH_SUBSCRIPTION, component: PanelComponent, canActivate: [AuthenticationService], children: [
    { path: '', component: SubscriptionComponent, outlet: 'panel'}
  ] },
  { path: DPO_CONSTANT.PATH_CONSULTATION, component: PanelComponent, canActivate: [AuthenticationService], children: [
    { path: '', component: ConsultationComponent, outlet: 'panel'}
  ] },
  { path: DPO_CONSTANT.PATH_SUBSCRIPTIONVALIDATED, component: SubscriptionValidatedComponent},				 // CAP-26096_POUDG-8493: Lot-2 related changes
  { path: DPO_CONSTANT.PATH_ISALIVE, component: IsAliveComponent}
];


// Register paths with Angular routing
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class RoutingModule { }
